export const TOOLTIP_ARROW_WIDTH = 24;
export const TOOLTIP_ARROW_HEIGHT = 12;
export const TOOLTIP_TOP_OFFSET = 8;
export const MIN_SPACE_FOR_ARROW = 20;
